export default function debounce(f, wait) {
    let timeout;
    return async (...args) => {
        clearTimeout(timeout);
        return new Promise((resolve, reject) => {
            timeout = setTimeout(() => {
                try {
                    resolve(f(...args));
                }
                catch (e) {
                    reject(e);
                }
            }, wait);
        });
    };
}
